<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h5>Performing action...</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { digitalLoadMethods, layoutMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  props: ["token", "action"],
  methods: {
    ...digitalLoadMethods,
    ...layoutMethods,
    goToList(){
      this.$router.push({ name:"E-Load Topups", hash: '#campaign' });
    }
  },
  mounted() {
    this.changeTitle({title: 'E-Load Campaign Action'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Digital Load', to: { name: 'Digital Load'} },
        { text: 'E-Load Topups', to: { name: 'E-Load Topups'} },
        { text: 'E-Load Action', to: { name: 'E-Load Campaign Action'} }
      ]
    });

    this.performCampaignAction({
      token: this.token,
      action: this.action
    })
      .then(() => {
        Swal.fire({
          title: "Action Successful!",
          text: `Eload campaign has been ${this.action} successfully.`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#c4297c",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Action Failed!",
          html: `Eload campaign has not been ${this.action}.<br />${error}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#c4297c",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      });
  }
};
</script>

<style>
</style>